;(function() {
  'use strict';

  var NAMESPACE = '.dailyMatchesModal';

  // --- ユーティリティ ---
  function formatPoint(val) {
    var v = parseFloat(val);
    if (v === 0) return '0.0';
    return (v > 0 ? '+' : '') + v.toFixed(1);
  }

  // --- DOM構築（jQuery DOM作成API、.text()による自動エスケープ） ---
  function buildMatchCard(match) {
    var $card = $('<a>', { href: match.url, class: 'daily-match-card clickable-card' });

    // 時間行
    var $time = $('<div>', { class: 'daily-match-card__time' })
      .append(
        $('<div>', { class: 'daily-match-card__time-label' })
          .append($('<i>', { class: 'bx bx-time-five', 'aria-hidden': 'true' }))
          .append($('<span>').text(match.time))
      )
      .append($('<i>', { class: 'bx bx-chevrons-right daily-match-card__link-icon', 'aria-hidden': 'true' }));
    $card.append($time);

    // プレイヤー行
    var $players = $('<div>', { class: 'daily-match-card__players' });
    match.results.forEach(function(result) {
      var $row = $('<div>', { class: 'daily-match-card__player-row' });

      var nameClass = 'daily-match-card__player-name';
      if (result.is_current_user) nameClass += ' is-current-user';
      var $name = $('<span>', { class: nameClass }).text(result.player_name);

      var ptVal = parseFloat(result.point);
      var ptClass = 'daily-match-card__player-pt ' + (ptVal >= 0 ? 'text-plus' : 'text-minus');
      var $pt = $('<span>', { class: ptClass }).text(formatPoint(result.point));

      $row.append($name).append($pt);
      $players.append($row);
    });
    $card.append($players);
    return $card;
  }

  // --- モーダル操作 ---
  function openModal(date, totalPoint, matchCount, matches) {
    var $modal = $('#daily-matches-modal');
    if ($modal.length === 0) return;

    // I18nラベルをdata属性から取得
    var labelMatches = $modal.data('label-matches') || '対局';
    var labelPt = $modal.data('label-pt') || 'pt';

    // ヘッダー: 日付（大）+ ポイント（色付き）+ 対局数（小さめ）
    var $title = $modal.find('#daily-matches-modal-title');
    $title.empty();

    var $date = $('<span>', { class: 'daily-matches-modal__date' }).text(date);
    $title.append($date);

    var ptVal = parseFloat(totalPoint);
    var ptClass = 'daily-matches-modal__pt ' + (ptVal > 0 ? 'text-plus' : (ptVal < 0 ? 'text-minus' : ''));
    var $pt = $('<span>', { class: ptClass }).text(formatPoint(totalPoint) + labelPt);
    $title.append($pt);

    var $count = $('<span>', { class: 'daily-matches-modal__count' }).text(matchCount + labelMatches);
    $title.append($count);

    // カードリスト
    var $body = $modal.find('.daily-matches-modal__body');
    $body.empty();
    var matchesArr = (typeof matches === 'string') ? JSON.parse(matches) : matches;
    matchesArr.forEach(function(match) {
      $body.append(buildMatchCard(match));
    });

    // アニメーション表示
    $modal.css('display', 'flex').addClass('starting');
    $modal.find('.daily-matches-modal').addClass('starting');
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        $modal.removeClass('starting');
        $modal.find('.daily-matches-modal').removeClass('starting');
      });
    });

    // ESCキーで閉じる
    $(document).on('keydown' + NAMESPACE, function(e) {
      if (e.key === 'Escape') closeModal();
    });
  }

  function closeModal() {
    var $modal = $('#daily-matches-modal');
    if (!$modal.is(':visible')) return;
    var $panel = $modal.find('.daily-matches-modal');
    $modal.addClass('starting');
    $panel.addClass('starting');
    var finished = false;
    var end = function() {
      if (finished) return;
      finished = true;
      $modal.off('transitionend', end);
      $modal.hide();
    };
    $modal.on('transitionend', end);
    setTimeout(end, 420);
    $(document).off('keydown' + NAMESPACE);
  }

  // グローバル公開（index.js.erbからclose呼び出し用）
  window.DailyMatchesModal = { close: closeModal };

  // --- イベントバインド（イベント委譲: $(document)に登録） ---
  $(document).on('click' + NAMESPACE, '.js-calendar-day-clickable', function() {
    var $td = $(this);
    openModal(
      $td.data('date'),
      $td.data('total-point'),
      $td.data('match-count'),
      $td.data('matches')
    );
  });

  $(document).on('click' + NAMESPACE, '#daily-matches-modal-close', function() {
    closeModal();
  });

  $(document).on('click' + NAMESPACE, '#daily-matches-modal', function(e) {
    if (e.target === this) closeModal();
  });

  // Turbolinksキャッシュ前にクリーンアップ
  $(document).on('turbolinks:before-cache', function() {
    var $modal = $('#daily-matches-modal');
    if ($modal.is(':visible')) {
      $modal.hide().removeClass('starting');
      $modal.find('.daily-matches-modal').removeClass('starting');
    }
    $(document).off('keydown' + NAMESPACE);
  });
})();
